module.exports = __webpack_public_path__ + "img/flashcredentials.96426220.png";